import { Component, OnInit } from '@angular/core';
import { JeevesOpenOrdersComponent } from 'gung-standard-jeeves';
import { RefJeevesOpenOrdersListTableConfigService } from '../../services/ref-jeeves-open-orders-list-table-config/ref-jeeves-open-orders-list-table-config.service';

@Component({
    selector: 'ref-jeeves-open-orders',
    template: '<lib-filter-list [configService]="config"></lib-filter-list>',
    styles: [''],
    standalone: false
})
export class RefJeevesOpenOrdersComponent extends JeevesOpenOrdersComponent implements OnInit {
  constructor(public config: RefJeevesOpenOrdersListTableConfigService) {
    super(config);
  }

  ngOnInit() {}
}
